import React, { useState, useEffect } from 'react';
import Carousel from "react-spring-3d-carousel";
import { ProjectCard } from "../components";
import { slides } from "../data"
import { config } from "react-spring";
import '../styles/Project.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import LazyLoad from 'react-lazy-load';


export default function Projects() {
    const [slideIndex, setSlideIndex] = useState(0);
    const [projects, setProject] = useState([]);

    useEffect(() => {
        let projectArray = [];
        projectArray = slides.map((slide, key) => {
            return {
                ...projects,
                key: key,
                content: <ProjectCard
                    fileLink={slide.fileLink}
                    title={slide.title}
                    content={slide.content}
                    stacks={slide.stacks}
                    url={slide.url}
                />,
            };
        });
        setProject(projectArray)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className="content-bg my-5 p-5">
            <div className="direction" style={{ width: "72vw" }}>
                <div className="d-flex flex-row justify-content-between">
                    <FontAwesomeIcon
                        icon={faArrowLeft} size="lg"
                        className={slideIndex === 0 ? "mx-2 text-muted" : "mx-2"}
                        onClick={() => {
                            slideIndex > 0 && setSlideIndex(slideIndex - 1)
                        }} />
                    <FontAwesomeIcon
                        icon={faArrowRight} size="lg"
                        className={projects.length === slideIndex ? "mx-2 text-muted" : "mx-2"}
                        onClick={() => {
                            projects.length > slideIndex && setSlideIndex(slideIndex + 1)
                        }} />
                </div>
            </div>
            <LazyLoad height={"100%"} offsetVertical={300}>
                <div className="mx-auto m-5 carousel-card" style={{ width: "80%", height: "80%" }}>
                    <Carousel
                        slides={projects}
                        goToSlide={slideIndex}
                        offsetRadius={2}
                        showNavigation={false}
                        animationConfig={config.gentle}
                    />
                    <div className="counter">
                        <div className="row">
                            <div>{slideIndex}</div>
                            <hr style={{ width: "100px" }} />
                            <div>{projects.length}</div>
                        </div>
                    </div>
                </div>
            </LazyLoad>
        </div>
    )
}
